import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API } from '../api/URL_API';

// Crear el contexto
const SucursalContext = createContext();

// Proveedor del contexto
export const SucursalProvider = ({ children }) => {
    const [idSucursal, setIdSucursal] = useState(null); // Estado para el idSucursal
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSucursal = async () => {
            try {
                if (!idSucursal) {
                    const response = await axios.get(`${API}/api/sucursales-poner/primer`);
                    const defaultId = response.data.idSucursal;
                    setIdSucursal(defaultId);
                }
            } catch (error) {
                console.error('Error al obtener el id de la sucursal:', error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchSucursal();
    }, [idSucursal]); // Solo ejecuta al montar el componente

    return (
        <SucursalContext.Provider value={{ idSucursal, setIdSucursal, loading }}>
            {children}
        </SucursalContext.Provider>
    );
};

// Hook para acceder al contexto
export const useSucursal = () => {
    const context = useContext(SucursalContext);
    if (!context) {
        throw new Error('useSucursal debe ser usado dentro de un SucursalProvider');
    }
    return context;
};
